export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '坤策集团',

    /** 公司名称 */
    name: '上海坤策文化传播有限公司',
    /** 公司微信 */
    wechat: 'GZWjxxxt',
    /** 公司邮箱 */
    email: 'wjhsmarter@xx.com',
    /** 公司手机 */
    phone: '18279xx225',
    /** 公司电话 */
    tel: '021-182xxx225',
    /** 公司地址 */
    address: '浦东新区xxx大厦1号楼5楼703',
    /** 备案号 */
    keepOnRecordIcp: '沪ICP备xxx号',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 121.526896,
        latitude: 31.24022,
        title: 'xxx大厦',
        address: '浦东新区xxx大厦1号楼5楼xxx'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js